import React, { useState } from "react";
import UIkit from "uikit";
import Constants from "../../../utils/Constants";
import { useForm } from "react-hook-form";
import axios from "axios";

const EditCustomer = ({ customerDetails, refetch }) => {
  const [loader, setLoader] = useState(false);

  const {
    register: RegisterCust,
    handleSubmit: handleCustsubmit,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {
      fullname: customerDetails?.fullname || "",
      fatherName: customerDetails?.fatherName || "",
      gender: customerDetails?.gender || "",
      ntn: customerDetails?.ntn || "",
      organizationName: customerDetails?.organizationName || "",
      salesTax: customerDetails?.salesTax || "",
      type: customerDetails?.type || "individual",
      dob: customerDetails?.dob || "",
      email: customerDetails?.email || "",
      phone: customerDetails?.phone || "",
      secondaryPhone: customerDetails?.secondaryPhone || "",
      city: customerDetails?.city || "",
      address: customerDetails?.address || "",
      cnic: customerDetails?.cnic || "",
    }
  });

  const Update = (data) => {
    // Check if at least one field has been modified
    const hasChanges = Object.entries(data).some(([key, value]) => {
      const originalValue = customerDetails[key];
      return value !== "" && value !== originalValue;
    });

    if (!hasChanges) {
      window.swal({
        icon: "error",
        title: "No changes made",
        text: "Please modify at least one field before updating"
      });
      return;
    }

    setLoader(true);

    // Filter out empty fields from the data object
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== "")
    );

    axios({
      method: "patch",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: filteredData,
      url: Constants.url + `customers/update/${customerDetails._id}`,
    })
      .then((res) => {
        setLoader(false);

        if (res.data.status === "success") {
          UIkit.modal(`#editCustomerModal`).hide();

          window
            .swal({
              icon: "success",
              title: "Updated successfully",
            })
            .then(() => UIkit.modal(`#editCustomerModal`).hide());

          refetch();
        } else {
          window
            .swal({
              icon: "error",
              title: res.data.status,
            })
            .then(() => UIkit.modal(`#editCustomerModal`).hide());
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <form
      className="uk-form-stacked uk-padding"
      onSubmit={handleCustsubmit(Update)}
    >
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-2">
          <div className="uk-margin">
            <label
              className="uk-form-label uk-heading-small"
              htmlFor="firstName"
            >
              Full Name
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="fullname"
                type="text"
                {...RegisterCust("fullname", {
                  validate: {
                    notEmpty: (value) => value !== "" || "Full Name is required",
                  }
                })}
                placeholder="Full Name"
              />
              {errors.fullname && (
                <span className="uk-text-danger">{errors.fullname.message}</span>
              )}
            </div>
          </div>

          <div className="uk-margin">
            <label
              className="uk-form-label uk-heading-small"
              htmlFor="firstName"
            >
              Father/Husband Name 
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="fatherName"
                type="text"
                {...RegisterCust("fatherName")}
                placeholder="Father/Husband Name"
              />
            </div>
          </div>

          <div className="uk-margin">
            <label
              className="uk-form-label uk-heading-small"
              htmlFor="firstName"
            >
              Gender
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="gender"
                type="text"
                {...RegisterCust("gender")}
                placeholder="gender"
              />
            </div>
          </div>

          {customerDetails?.type === "corporate" ? (
            <div className="uk-margin">
              <label
                className="uk-form-label uk-heading-small"
                htmlFor="firstName"
              >
                NTN
              </label>
              <div className="uk-form-controls">
                <input
                  className="uk-input uk-form-medium"
                  id="NTN"
                  type="text"
                  {...RegisterCust("ntn")}
                  placeholder="ntn"
                />
              </div>
            </div>
          ) : (
            ""
          )}

          {customerDetails?.type === "corporate" ? (
            <div className="uk-margin">
              <label
                className="uk-form-label uk-heading-small"
                htmlFor="organizationName"
              >
                Company Name
              </label>
              <div className="uk-form-controls">
                <input
                  className="uk-input uk-form-medium"
                  id="organizationName"
                  type="text"
                  {...RegisterCust("organizationName")}
                  placeholder="Company Name"
                />
              </div>
            </div>
          ) : (
            ""
          )}

          {customerDetails?.type === "corporate" ? (
            <div className="uk-margin">
              <label
                className="uk-form-label uk-heading-small"
                htmlFor="salesTax"
              >
                Sales Tax
              </label>
              <div className="uk-form-controls">
                <input
                  className="uk-input uk-form-medium"
                  id="salesTax"
                  type="text"
                  {...RegisterCust("salesTax")}
                  placeholder="Sales Tax"
                />
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="uk-margin">
            <label className="uk-form-label uk-heading-small" htmlFor="type">
              Type
            </label>

            <select
              className="uk-select"
              {...RegisterCust("type")}
              defaultValue={customerDetails?.type}
            >
              <option value="individual">Individual</option>
              <option value="corporate">Corporate</option>
            </select>
          </div>

          <div className="uk-margin">
            <label
              className="uk-form-label uk-heading-small"
              htmlFor="firstName"
            >
              Date of Birth
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="dob"
                type="date"
                {...RegisterCust("dob")}
                placeholder="Date of Birth"
              />
            </div>
          </div>
        </div>

        <div className="uk-width-1-2">
          <div className="uk-margin">
            <label className="uk-form-label uk-heading-small" htmlFor="email">
              Email
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="email"
                type="email"
                {...RegisterCust("email", {
                  validate: {
                    notEmpty: (value) => value !== "" || "Email is required",
                    validEmail: (value) => {
                      if (value === "") return true;
                      return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) || "Invalid email address"
                    }
                  }
                })}
                placeholder="Email"
              />
              {errors.email && (
                <span className="uk-text-danger">{errors.email.message}</span>
              )}
            </div>
          </div>

          <div className="uk-margin">
            <label className="uk-form-label uk-heading-small" htmlFor="phone">
              Phone
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="phone"
                type="text"
                {...RegisterCust("phone", {
                  validate: {
                    notEmpty: (value) => value !== "" || "Phone is required",
                    validPhone: (value) => {
                      if (value.length !== 11) return "Invalid Phone number ";
                      return true;
                    }
                  }
                })}
                placeholder="Phone"
              />
              {errors.phone && (
                <span className="uk-text-danger">{errors.phone.message}</span>
              )}
            </div>
          </div>

          <div className="uk-margin">
            <label className="uk-form-label uk-heading-small" htmlFor="phone">
              Secondary Phone
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="secondaryPhone"
                type="text"
                {...RegisterCust("secondaryPhone" , {
                  validate: {
                    validPhone: (value) => {
                      if (value.length !== 11) return "Invalid Phone number ";
                      return true;
                    }
                  }
                } )}
                placeholder="Secondary Phone"
              />
            </div>
          </div>

          <div className="uk-margin">
            <label className="uk-form-label uk-heading-small" htmlFor="city">
              City
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="city"
                type="text"
                {...RegisterCust("city")}
                placeholder="City"
              />
            </div>
          </div>

          <div className="uk-margin">
            <label className="uk-form-label uk-heading-small" htmlFor="address">
              Address
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="address"
                type="text"
                {...RegisterCust("address")}
                placeholder="Address"
              />
            </div>
          </div>

          <div className="uk-margin">
            <label className="uk-form-label uk-heading-small" htmlFor="cnic">
              CNIC
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input uk-form-medium"
                id="cnic"
                type="text"
                {...RegisterCust("cnic")}
                placeholder="CNIC"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="uk-margin uk-flex uk-flex-center">
        <button
          className="uk-button uk-button-secondary uk-button-medium uk-width-1-1"
          type="submit"
          disabled={loader}
        >
          {loader ? <div uk-spinner="" className="loader"></div> : "Update"}
        </button>
      </div>
    </form>
  );
};

export default EditCustomer;
